<template>
    <div>
        <Index></Index>
    </div>
</template>

<script>
import Index from "@partitions/.components/provider/partitions/index.vue"
export default {
    name: "PartitionsMain",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        Index
    }
}
</script>
